import { motion } from "framer-motion";
import { StyledButton as Button } from "Components/Button/StyledButton";

export default function HeroSection() {
  const scrollToNext = () => {
    const element = document.getElementById("founder-story");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden w-full">
      {/* Background gradient */}
      <div className="absolute inset-0 bg-gradient-to-br from-green-50 via-white to-green-100" />

      {/* Content */}
      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <motion.h1
          className="text-4xl md:text-6xl font-bold text-gray-900 mb-4 md:mb-6"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          Empowering Every Student's{" "}
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-green-600 to-green-400">
            Global Dream
          </span>
        </motion.h1>

        <motion.p
          className="text-xl md:text-2xl text-gray-600 mb-8 md:mb-12 max-w-3xl mx-auto"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
        >
          Meet the team of engineers, educators, and advisors reshaping education.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.6 }}
        >
          <Button
            onClick={scrollToNext}
            className="p-1 text-lg transition-all duration-300 w-full md:w-1/2"
          >
            Learn Our Story →
          </Button>
        </motion.div>
      </div>

      {/* Parallax elements */}
      <motion.div
        className="absolute top-20 left-10 w-20 h-20 bg-green-200 rounded-full opacity-20"
        animate={{ y: [0, -20, 0] }}
        transition={{ duration: 4, repeat: Number.POSITIVE_INFINITY }}
      />
      <motion.div
        className="absolute bottom-20 right-10 w-32 h-32 bg-green-300 rounded-full opacity-10"
        animate={{ y: [0, 20, 0] }}
        transition={{ duration: 6, repeat: Number.POSITIVE_INFINITY }}
      />
    </section>
  );
}
